import { render, staticRenderFns } from "./buyModal.vue?vue&type=template&id=22cb3b36&scoped=true&"
import script from "./buyModal.vue?vue&type=script&lang=js&"
export * from "./buyModal.vue?vue&type=script&lang=js&"
import style0 from "./buyModal.vue?vue&type=style&index=0&id=22cb3b36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb3b36",
  null
  
)

export default component.exports